/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme, { buttonReset } from '../../styles/theme';
import { questionAndAnswerType } from '../../propTypes/questionAndAnswer';

class FaqItem extends Component {
  state = {
    open: false,
  };

  toggleOpen = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  };

  renderQuestion() {
    const { classes, item } = this.props;
    const { open } = this.state;
    return (
      <button type="button" className={classes.question} onClick={this.toggleOpen}>
        <span>
          {item.question.text}
        </span>
        <svg className={cn(classes.questionIcon, { open })} viewBox="0 0 8 8">
          <path fill="currentColor" d="M4 6.67l-4-4 .998.001L3.997 5.631l3-3L8 2.67l-4 4Z" />
        </svg>
      </button>
    );
  }

  renderAnswer() {
    const { classes, item } = this.props;
    const { open } = this.state;
    return (
      <div className={cn(classes.answer, 'faq-answer', { open })}>
        <div className={cn(classes.answerInner, 'faq-answer-inner')}>
          {item.answer && (
            <div
              className={classes.answerText}
              dangerouslySetInnerHTML={{ __html: item.answer.html }}
            />
          )}
        </div>
      </div>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        {this.renderQuestion()}
        {this.renderAnswer()}
      </div>
    );
  }
}

FaqItem.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  item: questionAndAnswerType.isRequired,
};

FaqItem.defaultProps = {};

export default compose(
  injectSheet({
    container: {
      maxWidth: 768,
      margin: 'auto',
      marginBottom: 48,
      position: 'relative',
      '&:after': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        height: 1,
        bottom: -24,
        backgroundColor: theme.colors.dividingLine,
      },
    },
    question: {
      ...buttonReset({
        display: 'flex',
        justifyContent: 'space-between',
        fontWeight: 700,
        cursor: 'pointer',
        alignItems: 'center',
        fontSize: 16,
        width: '100%',
        textAlign: 'left',
        textTransform: 'none',
        '&:hover, &:focus': {
          color: 'currentColor',
        },
      }),
      '& > *:first-child': {
        flex: '1 1 auto',
      },
      '& span': {
        maxWidth: '93.75%',
      },
    },
    questionIcon: {
      width: 16,
      height: 16,
      flex: '0 0 auto',
      transition: 'transform 0.15s ease-in-out',
      '&.open': {
        transform: 'rotate(180deg)',
      },
    },
    answer: {
      display: 'grid',
      gridTemplateRows: '0fr',
      maxWidth: '93.75%',
      overflow: 'hidden',
      transition: 'grid-template-rows 0.3s ease-in-out',
      '&.open': {
        gridTemplateRows: '1fr',
      },
    },
    answerInner: {
      minHeight: 0,
      '& > div > p': {
        fontFamily: theme.fonts.body,
      },
    },
    answerText: {
      paddingTop: 16,
      '& p:last-child': {
        marginBottom: 0,
      },
    },
  }),
)(FaqItem);
